import type { UseFormReturn } from 'react-hook-form'
import { CardHeader, Input, Select } from '@orientamos/ui'
import type { IntakeFormData } from '@orientamos/shared'

interface Step2Props {
  form: UseFormReturn<IntakeFormData>
}

const propertyTypes = [
  { value: 'apartamento', label: 'Apartamento' },
  { value: 'casa', label: 'Casa' },
  { value: 'local', label: 'Local Comercial' },
  { value: 'oficina', label: 'Oficina' },
  { value: 'bodega', label: 'Bodega' },
  { value: 'lote', label: 'Lote' },
  { value: 'parqueadero', label: 'Parqueadero' },
]

const stratumOptions = [
  { value: '1', label: 'Estrato 1' },
  { value: '2', label: 'Estrato 2' },
  { value: '3', label: 'Estrato 3' },
  { value: '4', label: 'Estrato 4' },
  { value: '5', label: 'Estrato 5' },
  { value: '6', label: 'Estrato 6' },
]

export function Step2Property({ form }: Step2Props) {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = form

  const propertyType = watch('property.propertyType')
  const stratum = watch('property.stratum')

  return (
    <div className="space-y-8">
      <CardHeader
        title="Informacion del Inmueble"
        description="Ingresa los datos de la propiedad a arrendar"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <Input
            label="Direccion del Inmueble"
            placeholder="Ej: Calle 10 #43-25, Apto 501"
            {...register('property.address')}
            error={errors.property?.address?.message}
          />
        </div>

        <Input
          label="Nombre del Edificio o Conjunto (opcional)"
          placeholder="Ej: Edificio El Tesoro"
          {...register('property.buildingName')}
          error={errors.property?.buildingName?.message}
        />

        <Select
          label="Tipo de Inmueble"
          options={propertyTypes}
          value={propertyType}
          onChange={(e) =>
            setValue(
              'property.propertyType',
              e.target.value as
                | 'apartamento'
                | 'casa'
                | 'local'
                | 'oficina'
                | 'bodega'
                | 'lote'
                | 'parqueadero'
            )
          }
          error={errors.property?.propertyType?.message}
        />

        <Select
          label="Estrato"
          options={stratumOptions}
          value={String(stratum)}
          onChange={(e) => setValue('property.stratum', parseInt(e.target.value, 10))}
          error={errors.property?.stratum?.message}
        />

        <Input
          label="Area (m2)"
          type="number"
          min={1}
          placeholder="Ej: 85"
          {...register('property.area', { valueAsNumber: true })}
          error={errors.property?.area?.message}
        />

        <Input
          label="Ciudad"
          placeholder="Ej: Medellin"
          {...register('property.city')}
          error={errors.property?.city?.message}
        />

        <Input
          label="Parqueaderos"
          type="number"
          min={0}
          placeholder="0"
          {...register('property.parking', { valueAsNumber: true })}
          error={errors.property?.parking?.message}
        />

        <Input
          label="Cuartos Utiles / Depositos"
          type="number"
          min={0}
          placeholder="0"
          {...register('property.storage', { valueAsNumber: true })}
          error={errors.property?.storage?.message}
        />
      </div>
    </div>
  )
}
